import { render, staticRenderFns } from "./cottageTable.vue?vue&type=template&id=fbf5d5f6&scoped=true"
import script from "./cottageTable.vue?vue&type=script&lang=js"
export * from "./cottageTable.vue?vue&type=script&lang=js"
import style0 from "./cottageTable.vue?vue&type=style&index=0&id=fbf5d5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5d5f6",
  null
  
)

export default component.exports